import { MessageTypes } from '../constants';

export default {
  message: {
    type: MessageTypes.INFO,
    content: 'Welcome to Import Consignment',
  },
  user: {
    name: '',
  },
};
